import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Accident } from './accident.interface';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';



@Injectable({
    providedIn: 'root',
  })

  export class AccidentService {
    private apiUrl = `${environment.apiConfig.uri}/accident`;
    private apiUrlPdf =  `${environment.apiConfig.uri}/accident/getPdf`;
    constructor(private http: HttpClient) {
    }
  
    createAccident(newAccident: FormData): Observable<any> {
        return this.http.post(this.apiUrl, newAccident);
    }
  
    getAccidentPdfs(): Observable<any> {
        return this.http.get<any>(this.apiUrlPdf);
    }
  }

